import apiClient from './client';
import { endpoints } from './endpoints';
import type { Availability } from '@/types';

export const availabilityService = {
  async list(): Promise<Availability[] | unknown> {
    const response = await apiClient.get(endpoints.availability.list);
    return response.data;
  },
  async get(id: string): Promise<Availability | unknown> {
    const response = await apiClient.get(endpoints.availability.get(id));
    return response.data;
  },
  async getAvailableSlots(date: string): Promise<unknown> {
    const response = await apiClient.get(endpoints.availability.availableSlots, {
      params: { date },
    });
    return response.data;
  },
  async create(availabilityData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.post(endpoints.availability.create, availabilityData);
    return response.data;
  },
  async update(id: string, availabilityData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.put(endpoints.availability.update(id), availabilityData);
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.availability.delete(id));
    return response.data;
  },
};

export default availabilityService;
